import { Link } from 'react-router-dom'

export function TermsPage() {
  return (
    <div className="container mx-auto px-4 py-20 max-w-4xl">
      <h1 className="text-4xl font-bold mb-2">Terms of Service</h1>
      <h2 className="text-2xl text-muted-foreground mb-8">利用規約</h2>
      <div className="prose prose-gray max-w-none">
        <p className="text-muted-foreground mb-6">Last updated / 最終更新日: 2025-12-25</p>

        {/* Language Priority */}
        <section className="mb-8 p-4 bg-muted/30 rounded-lg">
          <h2 className="text-xl font-semibold mb-3">Language Priority / 言語の優先</h2>
          <div className="space-y-3">
            <p className="text-muted-foreground">
              <span className="font-medium text-foreground">English:</span>{' '}
              In case of any discrepancy between the Japanese and English versions of these Terms,
              the Japanese version shall prevail.
            </p>
            <p className="text-muted-foreground">
              <span className="font-medium text-foreground">日本語:</span>{' '}
              本規約の日本語版と英語版に相違がある場合、日本語版が優先します。
            </p>
          </div>
        </section>

        {/* 1. Acceptance of Terms */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">1. Acceptance of Terms / 規約への同意</h2>
          <div className="space-y-3">
            <p className="text-muted-foreground">
              <span className="font-medium text-foreground">English:</span>{' '}
              By accessing and using digem ("the Service"), you accept and agree to be bound by the terms
              and provisions of this agreement. If you do not agree to these terms, please do not use our Service.
            </p>
            <p className="text-muted-foreground">
              <span className="font-medium text-foreground">日本語:</span>{' '}
              digem（以下「本サービス」）にアクセスし利用することにより、お客様は本規約の条項に拘束されることに同意したものとみなされます。本規約に同意いただけない場合は、本サービスをご利用にならないでください。
            </p>
          </div>
        </section>

        {/* 2. Description of Service */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">2. Description of Service / サービスの説明</h2>
          <div className="space-y-3">
            <p className="text-muted-foreground">
              <span className="font-medium text-foreground">English:</span>{' '}
              digem is a Figma plugin that provides AI-powered slide generation capabilities.
              The Service allows users to create and manage presentation templates within Figma.
            </p>
            <p className="text-muted-foreground">
              <span className="font-medium text-foreground">日本語:</span>{' '}
              digemは、AIを活用したスライド生成機能を提供するFigmaプラグインです。本サービスにより、ユーザーはFigma内でプレゼンテーションテンプレートを作成・管理することができます。
            </p>
          </div>
        </section>

        {/* 3. Account Eligibility */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">3. Account Eligibility / アカウント資格</h2>
          <div className="space-y-3">
            <div>
              <p className="text-muted-foreground mb-2">
                <span className="font-medium text-foreground">English:</span>{' '}
                To use the Service, you must:
              </p>
              <ul className="list-disc list-inside text-muted-foreground ml-4 space-y-1">
                <li>Be at least 18 years of age, or the age of majority in your jurisdiction</li>
                <li>Provide accurate and complete registration information</li>
                <li>Maintain the security of your account credentials</li>
                <li>Accept responsibility for all activities under your account</li>
              </ul>
            </div>
            <div>
              <p className="text-muted-foreground mb-2">
                <span className="font-medium text-foreground">日本語:</span>{' '}
                本サービスをご利用いただくには、以下の条件を満たす必要があります：
              </p>
              <ul className="list-disc list-inside text-muted-foreground ml-4 space-y-1">
                <li>18歳以上、または居住地域における成年年齢に達していること</li>
                <li>正確かつ完全な登録情報を提供すること</li>
                <li>アカウント認証情報のセキュリティを維持すること</li>
                <li>お客様のアカウントで行われるすべての活動について責任を負うこと</li>
              </ul>
            </div>
          </div>
        </section>

        {/* 4. Use License */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">4. Use License / 使用許諾</h2>
          <div className="space-y-3">
            <div>
              <p className="text-muted-foreground mb-2">
                <span className="font-medium text-foreground">English:</span>{' '}
                Permission is granted to use digem for personal or commercial purposes.
                This is the grant of a license, not a transfer of title. You may not:
              </p>
              <ul className="list-disc list-inside text-muted-foreground ml-4 space-y-1">
                <li>Modify or copy the plugin's source code</li>
                <li>Use the Service for any illegal purpose</li>
                <li>Transfer or redistribute the plugin files</li>
                <li>Attempt to reverse engineer the software</li>
              </ul>
            </div>
            <div>
              <p className="text-muted-foreground mb-2">
                <span className="font-medium text-foreground">日本語:</span>{' '}
                digemを個人または商用目的で使用する許可が付与されます。これはライセンスの付与であり、所有権の譲渡ではありません。以下の行為は禁止されています：
              </p>
              <ul className="list-disc list-inside text-muted-foreground ml-4 space-y-1">
                <li>プラグインのソースコードの改変またはコピー</li>
                <li>違法な目的での本サービスの使用</li>
                <li>プラグインファイルの譲渡または再配布</li>
                <li>ソフトウェアのリバースエンジニアリングの試み</li>
              </ul>
            </div>
          </div>
        </section>

        {/* 5. Prohibited Conduct */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">5. Prohibited Conduct / 禁止行為</h2>
          <div className="space-y-3">
            <div>
              <p className="text-muted-foreground mb-2">
                <span className="font-medium text-foreground">English:</span>{' '}
                You agree not to:
              </p>
              <ul className="list-disc list-inside text-muted-foreground ml-4 space-y-1">
                <li>Violate any applicable laws or regulations</li>
                <li>Infringe upon the intellectual property rights of others</li>
                <li>Use the Service to generate content that is defamatory, harassing, or threatening</li>
                <li>Attempt to gain unauthorized access to the Service or related systems</li>
                <li>Use automated tools to scrape or excessively access the Service</li>
                <li>Share your account credentials with third parties</li>
                <li>Use the AI features to generate illegal, harmful, or deceptive content</li>
              </ul>
            </div>
            <div>
              <p className="text-muted-foreground mb-2">
                <span className="font-medium text-foreground">日本語:</span>{' '}
                以下の行為を行わないことに同意するものとします：
              </p>
              <ul className="list-disc list-inside text-muted-foreground ml-4 space-y-1">
                <li>適用される法令に違反すること</li>
                <li>他者の知的財産権を侵害すること</li>
                <li>名誉毀損、嫌がらせ、脅迫となるコンテンツを生成すること</li>
                <li>本サービスまたは関連システムへの不正アクセスを試みること</li>
                <li>自動化ツールを使用して本サービスを過度にアクセスすること</li>
                <li>アカウント認証情報を第三者と共有すること</li>
                <li>AI機能を使用して違法、有害、または欺瞞的なコンテンツを生成すること</li>
              </ul>
            </div>
          </div>
        </section>

        {/* 6. Subscription & Billing */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">6. Subscription & Billing / サブスクリプションと請求</h2>
          <div className="space-y-3">
            <div>
              <p className="text-muted-foreground">
                <span className="font-medium text-foreground">English:</span>
              </p>
              <p className="text-muted-foreground mb-2">
                <strong>Billing Timing:</strong> Subscription fees are billed immediately at checkout.
                Your subscription will automatically renew monthly or annually based on your selected plan until you cancel.
              </p>
              <p className="text-muted-foreground">
                <strong>Payment Methods:</strong> We accept major credit cards through our payment processor, Stripe.
                You agree to provide accurate payment information and keep it updated.
              </p>
            </div>
            <div>
              <p className="text-muted-foreground">
                <span className="font-medium text-foreground">日本語:</span>
              </p>
              <p className="text-muted-foreground mb-2">
                <strong>請求タイミング:</strong> サブスクリプション料金は決済時に即座に請求されます。サブスクリプションは、キャンセルするまで、選択したプランに基づいて毎月または毎年自動的に更新されます。
              </p>
              <p className="text-muted-foreground">
                <strong>支払い方法:</strong> 決済代行業者Stripeを通じて、主要なクレジットカードでのお支払いを受け付けています。正確な支払い情報を提供し、最新の状態に保つことに同意するものとします。
              </p>
            </div>
          </div>
        </section>

        {/* 7. Refund Policy */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">7. Refund Policy / 返金ポリシー</h2>
          <div className="space-y-3">
            <div>
              <p className="text-muted-foreground mb-2">
                <span className="font-medium text-foreground">English:</span>{' '}
                Due to the digital nature of our Service, subscription fees are generally non-refundable
                once charged. However, we may provide refunds at our discretion in the following cases:
              </p>
              <ul className="list-disc list-inside text-muted-foreground ml-4 space-y-1">
                <li>Technical issues on our end that prevent you from using the Service</li>
                <li>Duplicate charges or billing errors</li>
                <li>As required by applicable law</li>
              </ul>
              <p className="text-muted-foreground mt-2">
                To request a refund, please contact us through our{' '}
                <Link to="/contact" className="underline">contact form</Link>.
              </p>
            </div>
            <div>
              <p className="text-muted-foreground mb-2">
                <span className="font-medium text-foreground">日本語:</span>{' '}
                本サービスのデジタルな性質上、サブスクリプション料金は一度請求されると原則として返金されません。ただし、以下の場合には当社の裁量により返金を行う場合があります：
              </p>
              <ul className="list-disc list-inside text-muted-foreground ml-4 space-y-1">
                <li>当社の技術的な問題により、お客様がサービスを利用できない状態が継続した場合</li>
                <li>二重請求またはその他の決済エラーが発生した場合</li>
                <li>法令により返金が求められる場合</li>
              </ul>
              <p className="text-muted-foreground mt-2">
                返金をご希望の場合は、<Link to="/contact" className="underline">お問い合わせフォーム</Link>よりご連絡ください。
              </p>
            </div>
          </div>
        </section>

        {/* 8. Cancellation Policy */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">8. Cancellation Policy / 解約ポリシー</h2>
          <div className="space-y-3">
            <div>
              <p className="text-muted-foreground mb-2">
                <span className="font-medium text-foreground">English:</span>{' '}
                You may cancel your subscription at any time through the Billing Portal accessible
                from the plugin settings. Upon cancellation:
              </p>
              <ul className="list-disc list-inside text-muted-foreground ml-4 space-y-1">
                <li>You will retain access to paid features until the end of your current billing period</li>
                <li>Your account will be automatically downgraded to the Free plan</li>
                <li>No partial refunds will be issued for the remaining period</li>
              </ul>
            </div>
            <div>
              <p className="text-muted-foreground mb-2">
                <span className="font-medium text-foreground">日本語:</span>{' '}
                プラグインの設定からアクセスできる請求ポータルより、いつでもサブスクリプションを解約できます。解約後：
              </p>
              <ul className="list-disc list-inside text-muted-foreground ml-4 space-y-1">
                <li>現在の請求期間の終了まで有料機能へのアクセスを維持できます</li>
                <li>アカウントは自動的にFreeプランにダウングレードされます</li>
                <li>残存期間に対する日割り返金は行われません</li>
              </ul>
            </div>
          </div>
        </section>

        {/* 9. User Content */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">9. User Content / ユーザーコンテンツ</h2>
          <div className="space-y-3">
            <p className="text-muted-foreground">
              <span className="font-medium text-foreground">English:</span>{' '}
              You retain ownership of all content you create using digem. By using the Service,
              you grant us a limited license to process your content solely for the purpose of
              providing the Service.
            </p>
            <p className="text-muted-foreground">
              <span className="font-medium text-foreground">日本語:</span>{' '}
              digemを使用して作成したすべてのコンテンツの所有権はお客様に帰属します。本サービスを利用することにより、お客様は本サービスを提供する目的に限り、お客様のコンテンツを処理するための限定的なライセンスを当社に付与するものとします。
            </p>
          </div>
        </section>

        {/* 10. AI-Generated Content */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">10. AI-Generated Content / AI生成コンテンツ</h2>
          <div className="space-y-3">
            <div>
              <p className="text-muted-foreground mb-2">
                <span className="font-medium text-foreground">English:</span>{' '}
                The Service uses artificial intelligence to generate content. Please be aware that:
              </p>
              <ul className="list-disc list-inside text-muted-foreground ml-4 space-y-1">
                <li>AI-generated content may not always be accurate, complete, or appropriate</li>
                <li>Similar or identical outputs may be generated for different users</li>
                <li>You are solely responsible for reviewing and using AI-generated content</li>
                <li>The AI output does not constitute professional advice (legal, medical, financial, etc.)</li>
                <li>You should not input confidential, sensitive, or personal information into AI features</li>
              </ul>
            </div>
            <div>
              <p className="text-muted-foreground mb-2">
                <span className="font-medium text-foreground">日本語:</span>{' '}
                本サービスは人工知能を使用してコンテンツを生成します。以下の点にご注意ください：
              </p>
              <ul className="list-disc list-inside text-muted-foreground ml-4 space-y-1">
                <li>AI生成コンテンツは、常に正確、完全、または適切であるとは限りません</li>
                <li>異なるユーザーに対して、類似または同一の出力が生成される場合があります</li>
                <li>AI生成コンテンツのレビューと使用については、お客様が単独で責任を負います</li>
                <li>AI出力は専門的なアドバイス（法律、医療、財務など）を構成するものではありません</li>
                <li>AI機能に機密情報、センシティブな情報、個人情報を入力しないでください</li>
              </ul>
            </div>
          </div>
        </section>

        {/* 11. Suspension and Termination */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">11. Suspension and Termination / 利用停止と解除</h2>
          <div className="space-y-3">
            <div>
              <p className="text-muted-foreground mb-2">
                <span className="font-medium text-foreground">English:</span>{' '}
                We may suspend or terminate your access to the Service without prior notice if:
              </p>
              <ul className="list-disc list-inside text-muted-foreground ml-4 space-y-1">
                <li>You violate these Terms of Service</li>
                <li>You fail to pay subscription fees when due</li>
                <li>Your use poses a security risk to the Service or other users</li>
                <li>We are required to do so by law</li>
              </ul>
            </div>
            <div>
              <p className="text-muted-foreground mb-2">
                <span className="font-medium text-foreground">日本語:</span>{' '}
                以下の場合、当社は事前通知なく本サービスへのアクセスを停止または終了することがあります：
              </p>
              <ul className="list-disc list-inside text-muted-foreground ml-4 space-y-1">
                <li>本規約に違反した場合</li>
                <li>サブスクリプション料金の支払いを怠った場合</li>
                <li>お客様の利用が本サービスまたは他のユーザーにセキュリティ上のリスクをもたらす場合</li>
                <li>法令により必要とされる場合</li>
              </ul>
            </div>
          </div>
        </section>

        {/* 12. Disclaimer */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">12. Disclaimer / 免責事項</h2>
          <div className="space-y-3">
            <p className="text-muted-foreground">
              <span className="font-medium text-foreground">English:</span>{' '}
              The Service is provided on an "as is" and "as available" basis. digem makes no warranties,
              expressed or implied, and hereby disclaims implied warranties of merchantability,
              fitness for a particular purpose, or non-infringement of intellectual property.
            </p>
            <p className="text-muted-foreground">
              <span className="font-medium text-foreground">日本語:</span>{' '}
              本サービスは「現状有姿」および「利用可能な状態」で提供されます。digemは、明示または黙示を問わず、いかなる保証も行わず、商品性、特定目的への適合性、または知的財産権の非侵害に関する黙示の保証を否認します。
            </p>
          </div>
        </section>

        {/* 13. Limitation of Liability */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">13. Limitation of Liability / 責任の制限</h2>
          <div className="space-y-3">
            <div>
              <p className="text-muted-foreground">
                <span className="font-medium text-foreground">English:</span>{' '}
                Except in cases of willful misconduct or gross negligence, digem and its operators shall not
                be liable for any indirect, incidental, special, consequential, or punitive damages arising
                out of the use or inability to use the Service.
              </p>
              <p className="text-muted-foreground mt-2">
                In any case, our total liability shall not exceed the amount you have paid to us in the
                twelve (12) months preceding the claim.
              </p>
            </div>
            <div>
              <p className="text-muted-foreground">
                <span className="font-medium text-foreground">日本語:</span>{' '}
                当社の故意または重大な過失による場合を除き、digemおよびその運営者は、本サービスの使用または使用不能から生じる間接的、付随的、特別、結果的、または懲罰的損害について、一切責任を負いません。
              </p>
              <p className="text-muted-foreground mt-2">
                いかなる場合においても、当社の賠償責任の総額は、請求に先立つ12ヶ月間にお客様が当社に支払った金額を上限とします。
              </p>
            </div>
          </div>
        </section>

        {/* 14. Changes to Terms */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">14. Changes to Terms / 規約の変更</h2>
          <div className="space-y-3">
            <p className="text-muted-foreground">
              <span className="font-medium text-foreground">English:</span>{' '}
              We reserve the right to modify these terms at any time. We will notify users of any
              material changes via email or through the Service. Your continued use of the Service
              after such modifications constitutes acceptance of the updated terms.
            </p>
            <p className="text-muted-foreground">
              <span className="font-medium text-foreground">日本語:</span>{' '}
              当社は、いつでも本規約を変更する権利を留保します。重要な変更がある場合は、メールまたは本サービスを通じてユーザーに通知します。変更後も本サービスを継続して使用することにより、更新された規約に同意したものとみなされます。
            </p>
          </div>
        </section>

        {/* 15. Governing Law and Jurisdiction */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">15. Governing Law and Jurisdiction / 準拠法および管轄</h2>
          <div className="space-y-3">
            <p className="text-muted-foreground">
              <span className="font-medium text-foreground">English:</span>{' '}
              These Terms shall be governed by and construed in accordance with the laws of Japan.
              Any disputes arising from or related to these Terms shall be subject to the exclusive
              jurisdiction of the Tokyo District Court as the court of first instance.
            </p>
            <p className="text-muted-foreground">
              <span className="font-medium text-foreground">日本語:</span>{' '}
              本規約は日本法に準拠し、同法に従って解釈されるものとします。本規約に起因または関連する紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
            </p>
          </div>
        </section>

        {/* 16. Contact */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">16. Contact / お問い合わせ</h2>
          <div className="space-y-3">
            <p className="text-muted-foreground">
              <span className="font-medium text-foreground">English:</span>{' '}
              If you have any questions about these Terms, please contact us through our{' '}
              <Link to="/contact" className="underline">contact form</Link>.
            </p>
            <p className="text-muted-foreground">
              <span className="font-medium text-foreground">日本語:</span>{' '}
              本規約についてご質問がある場合は、<Link to="/contact" className="underline">お問い合わせフォーム</Link>よりご連絡ください。
            </p>
          </div>
          <div className="mt-4 text-muted-foreground">
            <p>Email: support@digemhq.com</p>
            <p>Contact Form: <a href="https://digemhq.com/contact" className="underline">https://digemhq.com/contact</a></p>
          </div>
        </section>
      </div>
    </div>
  )
}
